var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"merchant-success"},[_c('VueFeedback',{attrs:{"type":"success"}},[_c('template',{slot:"feedback-title"},[_vm._v("Köszönjük jelentkezését!")]),_c('template',{slot:"feedback-content"},[_vm._v("Munkatársunk hamarosan keresni fogja Önt a megadott elérhetőségek egyikén.")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }